import {autoTable} from 'jspdf-autotable';
import textVersion from 'textversionjs';
import {posAttributes, staticCaveats} from "../components/resultItems/CondensedCaveatAvatars";
import caveatColor from "../caveatColor";
import * as rptHelpers from "../Reports/ReportHelpers";
import {SECTION_TITLES} from '../containers/AnswersList';
import {criteriaColors} from "../reducer/response";
import {assessmentTiers} from "../components/resultItems/AssessmentTier";

export function OptionSummaryRpts(doc, selectedItems, options, answerTextLookup, questionLookup, notesList, fishery, pageOrientation, pageFormat, section, includeDesc, includeNotes, includeCrit, includeCavs, starred, translation){
  rptHelpers.addNewPage(doc);
  doc.setFont("helvetica");

  //*********************
  //Create the detail report for each option
  //*********************
  selectedItems.forEach((item, index) => {
    var firstPage = (index === 0) ? true : false;
    for(var i=0; i<options.length; i++){
      if(item === options[i].id){
        createOptionReport(options[i], doc, firstPage, answerTextLookup, questionLookup, notesList[item], fishery, pageOrientation, pageFormat, section, includeDesc, includeNotes, includeCrit, includeCavs, starred, translation);
        break;
      }
    }
  });
}

const createOptionReport = (option, doc, firstPage, answerTextLookup, questionLookup, noteHTML, fishery, pageOrientation, pageFormat, section, includeDesc, includeNotes, includeCrit, includeCavs, starred, translation) => {
  if(!firstPage){
    rptHelpers.addNewPage(doc);
  }

  var formatValues = rptHelpers.getFormatValues(doc);
  var splitWidth = formatValues.splitWidth;

  //***TITLE
  var yPos = 15;
  doc.setFontSize(20);
  doc.setFont(rptHelpers.RPTFONTSTYLE, "bold");
  var optionLabel = starred.indexOf(option.id) === -1 ? option.title : "*Top Option*\n" + option.title
  optionLabel = doc.splitTextToSize(optionLabel,splitWidth);
  doc.text(rptHelpers.HMARGIN, yPos, optionLabel);

  yPos+=optionLabel.length*7;
  var tempRJustYPos = yPos;

  doc.setFontSize(14);
  doc.setFont(rptHelpers.RPTFONTSTYLE, 'normal');

  var catLabel;
  if(section === "assessment"){
    catLabel = "Assessment Category: " + option.inputCategory.title;
    catLabel = doc.splitTextToSize(catLabel, splitWidth);
    doc.text(rptHelpers.HMARGIN, yPos, catLabel);
    yPos += catLabel.length*7;
    //add to doc separately to maintain even spacing
    catLabel = "Assessment Output: " + option.category.title;
    catLabel = doc.splitTextToSize(catLabel, splitWidth);
    doc.text(rptHelpers.HMARGIN, yPos, catLabel);
    yPos += catLabel.length*7;

    if(option.assessmentTier){
      let assessmentTierTitle = assessmentTiers.find(tier => tier.id === option.assessmentTier).title;
      catLabel = "Assessment 'Tier': " + assessmentTierTitle;
      catLabel = doc.splitTextToSize(catLabel, splitWidth);
      doc.text(rptHelpers.HMARGIN, yPos, catLabel);
      yPos += catLabel.length*7;
    }
  }else{
    catLabel = "Category: " + option.category.title;
    catLabel = doc.splitTextToSize(catLabel, splitWidth);
    doc.text(rptHelpers.HMARGIN, yPos, catLabel);
    yPos += catLabel.length*7;
  }


  var sectionLabel = "Section: " + SECTION_TITLES[section];
  doc.text(doc.internal.pageSize.getWidth()-rptHelpers.HMARGIN, tempRJustYPos, sectionLabel, null, null, 'right');
  tempRJustYPos += 7;

  var fisheryLabel = "Fishery: " + fishery;
  fisheryLabel = doc.splitTextToSize(fisheryLabel, splitWidth);
  doc.text(rptHelpers.HMARGIN, yPos, fisheryLabel);
  yPos += fisheryLabel.length*7;

  if(section !== "controlRules"){
    var numCritMet = rptHelpers.countCriteria(option.metCriteria, option);
    var numCritFailed = rptHelpers.countCriteria(option.eliminatedBy, option);
    var numCritTotal = numCritMet + numCritFailed;
    var critMetStr = " (" + numCritMet + " of " + numCritTotal + " met)";

    if(option.eliminated){
      doc.setFont(rptHelpers.RPTFONTSTYLE, "bold");
      doc.text(rptHelpers.HMARGIN, yPos, "This option does NOT meet all criteria" + critMetStr)
      doc.setFont(rptHelpers.RPTFONTSTYLE, "normal");
    }else{
      doc.text(rptHelpers.HMARGIN, yPos, "This option meets all criteria" + critMetStr)
    }
  }
  yPos += 7;

  //***DESCRIPTION
  if(includeDesc){
  yPos = rptHelpers.createTextSection(doc, yPos, textVersion(option.description), "Description", splitWidth);

  //***CONTACTS
  var contacts = option.contacts ? textVersion(option.contacts) : '';
  if(/\S/.test(contacts)){ //if there is non whitespace, then display
    yPos = rptHelpers.createTextSection(doc, yPos, contacts, "Contacts", splitWidth);
  }

  //***REFERENCES
  var references = option.references ? textVersion(option.references) : '';
  if(/\S/.test(references)){ //if there is non whitespace, then display
    yPos = rptHelpers.createTextSection(doc, yPos, references, "References", splitWidth);
  }
  }

  //***NOTES
  if(includeNotes){
  yPos = rptHelpers.addSubHeader(doc,yPos, "User Notes About This Option");

  rptHelpers.setBodyStyle(doc);
  var noteText = noteHTML ? doc.splitTextToSize(textVersion(noteHTML), splitWidth) : "No user notes were recorded at the time of report generation.";
  doc.text(rptHelpers.HMARGIN, yPos, noteText);
  yPos += noteHTML ? 5*noteText.length : 10;
  }

  //***MEETS CRITERIA
  if(includeCrit){
  if(section !== "controlRules"){
    yPos = rptHelpers.addSubHeader(doc, yPos, "Criteria");

    yPos = rptHelpers.newPageCheck(doc, yPos);
    doc.setFontSize(12);
    if(option.eliminated){
      doc.setFont(rptHelpers.RPTFONTSTYLE, "bold");
      doc.text(rptHelpers.HMARGIN, yPos, "This option does not meet the criteria for your fishery." + critMetStr)
      doc.setFont(rptHelpers.RPTFONTSTYLE, "normal");
    } else{
      doc.text(rptHelpers.HMARGIN, yPos, "This option meets all the criteria for your fishery." + critMetStr)
    }
    rptHelpers.setBodyStyle(doc);
    yPos += 5;

    var mcColumns = [
      {title: "Met/\nFailed", dataKey: "met"},
      {title: "Question", dataKey:"q"},
      {title: "Answer", dataKey:"answer"},
      {title: "Minimum\nCriteria", dataKey:"minCrit"},
    ];

    if(section === 'assessment'){
      mcColumns.splice(1,0, {title: "Single or\nMulti?", dataKey:'group'})
    }

    var mcData = []
    var minCrit;
    var groupAlphaCode = 64; //1 before 'A'
    var curOrID = -1;

    //failed criteria
    //todo: split into shared function for failed and met criteria in next iteration
    option.eliminatedBy.forEach((question) => {
      let answer = (question.answers || []).find((a) => a.id === question.answer)
      if(!question.or){
        minCrit = (question.answers || []).find((a) => a.id === question.domainLogic.criteria[option.id][0]);
      } else{
        var orQuestion = questionLookup[question.or];
        if(curOrID !== orQuestion.id){
          groupAlphaCode++;
          curOrID = orQuestion.id;
        }
        var criteron = orQuestion.domainLogic.criteria[option.id];
        //answers are in sorted order so minimum is first answer that is contained in criteron array
        minCrit = (question.answers || []).find((a) => criteron.find((crit) => a.id === crit))
      }

      let qTitle = question ? question.title : "Static Caveat"
      let answerText = answer ? answer.title : ""

      if(question && translation){
        var trQ = translation.questions.find(trQ => trQ.engID === question.id)
        if(trQ){
            qTitle = trQ.title
            answerText = trQ.answers.find(a => a.id === answer.id).title
        }
      }

      mcData.push({
        group: question.or ? "Multi " + String.fromCharCode(groupAlphaCode) + " Failed" : "Single Criteria",
        met: "Failed",
        q: rptHelpers.convertTextForjsPDF(qTitle),
        answer: rptHelpers.convertTextForjsPDF(answerText),
        minCrit: minCrit ? rptHelpers.convertTextForjsPDF(minCrit.title) : "",
      })
    });

    //met criteria
    option.metCriteria.forEach((question) => {
      let answer = (question.answers || []).find((a) => a.id === question.answer)
      let colorCode = criteriaColors.findIndex(color => color === question.color);
      if(!question.or){
        minCrit = (question.answers || []).find((a) => a.id === question.domainLogic.criteria[option.id][0]);
      } else{
        var orQuestion = questionLookup[question.or];
        if(curOrID !== orQuestion.id){
          groupAlphaCode++;
          curOrID = orQuestion.id;
        }
        var criteron = orQuestion.domainLogic.criteria[option.id];
        //answers are in sorted order so minimum is first answer that is contained in criteron array
        minCrit = (question.answers || []).find((a) => criteron.find((crit) => a.id === crit))
      }

      let qTitle = question ? question.title : "Static Caveat"
      let answerText = answer ? rptHelpers.convertTextForjsPDF(answer.title) : ""

      if(question && translation){
        var trQ = translation.questions.find(trQ => trQ.engID === question.id)
        if(trQ){
            qTitle = trQ.title
            answerText = trQ.answers.find(a => a.id === answer.id).title
        }
      }

      mcData.push({
        group: question.or ? "Multi " + String.fromCharCode(groupAlphaCode) + " Met" : "Single Criteria",
        met: (section === "assessment") ? "color:" + colorCode : "Met", //need to pass color here to get data to drawCell hook
        q: rptHelpers.convertTextForjsPDF(qTitle),
        answer: rptHelpers.convertTextForjsPDF(answerText),
        minCrit: minCrit ? rptHelpers.convertTextForjsPDF(minCrit.title) : "",
      })
    });

    if(mcData.length > 0){
      //set style to bold for all then unbold any met criteria. This gets around a autotable bug that
      //sets splits the string on width before bolding causing the bolded line to overflow its cell. This
      //workaround will cause the unbolded text to be short of the entire length of the cell
      doc.autoTable(mcColumns, mcData, {
        willDrawCell: customizeCritCells,
        headerStyles: {fillColor: option.eliminated ? [0,0,0] : [0,128,0]}, //black and green
        styles: {overflow: 'linebreak', fontStyle: 'bold'},
          columnStyles: {
            met: {columnWidth: 20},
            q:{columnWidth: 'auto'},
            group:{columnWidth: 20},
            minCrit:{mincellWidth: 20},
            answer: {minCellWidth: 20}
          },
        startY: yPos,
        showHeader: 'firstPage',
          rowPageBreak: 'avoid',
        addPageContent: rptHelpers.tableFooter,
        margin: {horizontal: rptHelpers.HMARGIN, bottom: 19},

      })
      yPos = doc.autoTable.previous.finalY + 10;
    }
  }
  }


  //***CAVEATS
  if(includeCavs){
  yPos = rptHelpers.addSubHeader(doc, yPos, "Caveats and Attributes");

  //red caveats
  var redCavs = option.caveats.filter((caveat) => (caveat.score === -3 && !caveat.static));
  yPos = cavSection(doc, "Red Caveats", redCavs, yPos, answerTextLookup, questionLookup, pageOrientation, pageFormat, translation);

  //orange caveats
  var orangeCavs = option.caveats.filter((caveat) => (caveat.score === -2 && !caveat.static));
  yPos = cavSection(doc, "Orange Caveats", orangeCavs, yPos, answerTextLookup, questionLookup, pageOrientation, pageFormat, translation);

  //yellow caveats
  var yellowCavs = option.caveats.filter((caveat) => (caveat.score === -1 && !caveat.static));
  yPos = cavSection(doc, "Yellow Caveats", yellowCavs, yPos, answerTextLookup, questionLookup, pageOrientation, pageFormat, translation);

  //green caveats (ie positive attributes)
  var greenCavs = posAttributes(option.caveats); //option.caveats.filter((caveat) => caveat.score === 2);
  yPos = cavSection(doc, "Positive Attributes", greenCavs, yPos, answerTextLookup, questionLookup, pageOrientation, pageFormat, translation);

  //static caveats
  var staticCavs = staticCaveats(option.caveats);
  yPos = staticCavSection(doc, staticCavs, yPos, answerTextLookup, questionLookup, pageOrientation, pageFormat);
}
}

export const customizeCritCells = (data) => {
  //if is a digit, then it is a met criteria and digit represents the color
  //use the color code to create the background color and replace with 'met'
  //criteria color code: 0:red, 1:orange, 2:yellow, 3:green
  if(data.section === 'body' && data.column.dataKey === 'met'){
    if(/^color:/.test(data.cell.raw) || data.cell.raw.includes("Met")){
      if(/^color:/.test(data.cell.raw)){
        //map criteria color to caveat color so can use rgb array in caveatcolor
        var color;
        var critFailedInMetMulti = false;
        switch(data.cell.raw){
          case "color:0": //red
            color = caveatColor(-3);
            break;
          case "color:1": //orange
            color = caveatColor(-2);
            break;
          case "color:2": //yellow
            color = caveatColor(-1);
            break;
          case "color:3": //green
            color = caveatColor(2);
            break;
          default: //default grey. This will be the case when one part of a multi fails
            color = caveatColor(0);
            critFailedInMetMulti = true;
            break;
        }

        data.doc.setFillColor(...color.primaryRGBArr);
        data.doc.setTextColor(0,0,0); //black

        if(critFailedInMetMulti){
            data.cell.text = ["Failed"];
            data.cell.raw = "Failed";
        } else{
            data.cell.text = ["Met"];
            data.cell.raw = "Met";
        }
      }
      data.doc.setFont(rptHelpers.RPTFONTSTYLE, 'normal');
      for(const cell of Object.values(data.row.cells)){
        cell.styles.fontStyle = 'normal';
      }
    } else if(data.cell.raw === "Failed" && data.row.cells.group != null){
      data.doc.setFillColor(0, 0, 0); //black
      data.doc.setTextColor(255, 255, 255); //white
    }
  }
}



function cavSection(doc, title, caveats, yPos, answerTextLookup, questionLookup, pageOrientation, pageFormat, translation){
  yPos = rptHelpers.newPageCheck(doc, yPos);
  doc.setFont(rptHelpers.RPTFONTSTYLE, "italic");
  doc.setFontSize(12);
  doc.text(rptHelpers.HMARGIN, yPos, title);

  var cavTitle = title === "Positive Attributes" ? "Positive Attribute" : "Caveat";
  var columns = [
    {title: "Question", dataKey:"q"},
    {title: "Answer", dataKey:"answer"},
    {title: cavTitle, dataKey:"caveat"}
  ];
  var data = [];

  caveats.forEach((caveat, index) => {
    var question = questionLookup[caveat.question];

    let qTitle = question ? question.title : "This caveat always applies to this option."
    let answerText = question ? answerTextLookup[question.id] : ""

    if(question && translation){
      var trQ = translation.questions.find(trQ => trQ.engID === question.id)
      if(trQ){
          qTitle = trQ.title
          let answerID = question.answers.find(a => a.title === answerText).id
          answerText = trQ.answers.find(a => a.id === answerID).title
      }
    }

    data.push({
      q: rptHelpers.convertTextForjsPDF(qTitle),
      answer: rptHelpers.convertTextForjsPDF(answerText),
      caveat: rptHelpers.convertTextForjsPDF(caveat.title)
    });
  });

  if(data.length > 0){
    yPos += 5;
    var score = caveats[0].static ? 0 : caveats[0].score; //static caveats should have grey color
    const color = caveatColor(score);
    var headerTextCol = (title.split(" ")[0].toLowerCase() === "yellow") ? [0,0,0] : [255,255,255];
    var cavStyles = (score === -3) ? {overflow: 'linebreak', fontStyle: 'bold'} : {overflow: 'linebreak'}

    doc.autoTable(columns, data, {
      headerStyles: {fillColor: color.primaryRGBArr, textColor:headerTextCol},
      styles: cavStyles,
      columnStyles: {answer: {minCellWidth:30}},
      startY: yPos,
      showHeader: 'firstPage',
      addPageContent: rptHelpers.tableFooter,
      rowPageBreak: 'avoid',
      margin: {horizontal: rptHelpers.HMARGIN, bottom: 19},
    })
    yPos = doc.autoTable.previous.finalY + 10;
  } else {
    rptHelpers.setBodyStyle(doc);
    yPos += 5;
    doc.text(20, yPos, "There are no " + title.toLowerCase() + ".");
    yPos += 10;
  }
  return yPos;
}

function staticCavSection(doc, caveats, yPos, answerTextLookup, questionLookup, pageOrientation, pageFormat){
  yPos = rptHelpers.newPageCheck(doc, yPos);
  doc.setFont(rptHelpers.RPTFONTSTYLE, "italic");
  doc.setFontSize(12);
  doc.text(rptHelpers.HMARGIN, yPos, "Static Caveats");
  yPos += 5;
  doc.setFontSize(10);
  doc.text(rptHelpers.HMARGIN, yPos, "These caveats always apply to this option.")

  var columns = [
    {title: "Static Caveat", dataKey:"caveat"}
  ];
  var data = [];

  caveats.forEach((caveat, index) => {
    var question = questionLookup[caveat.question];
    data.push({
      caveat: rptHelpers.convertTextForjsPDF(caveat.title)
    });
  });

  if(data.length > 0){
    yPos += 5;
    // var score = caveats[0].static ? 0 : caveats[0].score; //static caveats should have grey color
    const color = caveatColor(0);
    // var cavStyles = (score === -3) ? {overflow: 'linebreak', fontStyle: 'bold'} : {overflow: 'linebreak'}

    doc.autoTable(columns, data, {
      headerStyles: {fillColor: color.primaryRGBArr},
      styles: {overflow: 'linebreak'},
      //columnStyles: {q: {columnWidth: columnWidth}, caveat: {columnWidth: columnWidth}},
      //columnStyles: {answer: {minCellWidth:30}},
      startY: yPos,
      showHeader: 'firstPage',
      addPageContent: rptHelpers.tableFooter,
      rowPageBreak: 'avoid',
      margin: {horizontal: rptHelpers.HMARGIN, bottom: 19},
    })
    yPos = doc.autoTable.previous.finalY + 10;
  } else {
    rptHelpers.setBodyStyle(doc);
    yPos += 5;
    doc.text(20, yPos, "There are no static caveats.");
    yPos += 10;
  }
  return yPos;
}
